module.exports = __webpack_public_path__ + "static/img/2.9b9376d.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/4/7/3/zh/2.png
// module id = GZh7
// module chunks = 0